import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import './src/styles/global.css'

export const shouldUpdateScroll = () => {
  return false
}
